import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { HasFeature } from '@/components/Atoms/Permissions'
import { Card, CardContent } from '@/components/ui/card'
import { CasesFeature } from '@/lib/features/cases'
import { buildPath } from '@/routes'
import { Navigate, Outlet } from 'react-router'

export function CasesLayout() {
  return (
    <HasFeature
      feature={CasesFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb label="Cases" path={buildPath('/cases')} />

      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </HasFeature>
  )
}
